import React from "react";

import FilterOption from "@mapmycustomers/shared/enum/fieldModel/FilterOption";
import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import {
  IFilterComponentProps,
  IFilterInstance,
} from "@mapmycustomers/shared/types/fieldModel/IFilterConfig";
import User from "@mapmycustomers/shared/types/User";
import { LegacySimpleCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import ViewAsFilterComponent from "./ViewAsFilterComponent";

// fake operator, it's not really used, but we need to specify at least one
export const VIEW_AS_FILTER_OPERATORS = [FilterOperator.EQUALS];

const doesSupportValue = () => false;

interface UsersFilterProps extends IFilterComponentProps {}

const ViewAsFilter: IFilterInstance = {
  doesSupportOption: (option: FilterOption) => option === FilterOption.AVAILABLE_USERS,
  doesSupportValue,
  getComponent:
    (): React.FunctionComponent<UsersFilterProps> =>
    ({ className, disabled, onChange, options, placeholder, value }) => {
      const availableUsers = (options?.availableUsers as User[]) ?? [];
      const selectedUser = value.value
        ? availableUsers.find(({ id }) => id === value.value)
        : undefined;

      return (
        <ViewAsFilterComponent
          className={className}
          disabled={disabled}
          onChange={(user: undefined | User) => onChange?.({ ...value, value: user?.id })}
          placeholder={placeholder}
          users={availableUsers}
          value={selectedUser}
        />
      );
    },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getHumanReadableDescription: (value: LegacySimpleCondition, field: IField, options) => {
    return ""; // TBD later if needed
  },
};

export default ViewAsFilter;
